import { Pipe, PipeTransform } from '@angular/core';
import { User, AuthState } from '../../store/auth/auth.state';

@Pipe({
  name: 'email',
  standalone: true
})
export class EmailPipe implements PipeTransform {
  transform(value: User | AuthState | null): string {
    // If it's the full AuthState, extract the user
    if (value && 'user' in value) {
      value = (value as AuthState).user;
    }
    
    const user = value as User | null;
    if (!user || !user.email) return '';
    return user.email;
  }
} 